/* eslint-disable no-unused-vars */
import React, { useMemo, useContext } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';

import useQlikSessionObject from 'hooks/useQlikSessionObject';
import AppContext from '../AppContext';

const KPIWrapper = styled(Box, {})(({ theme }) => ({
    width: '100%',
    // height: '100%',
    backgroundImage: 'url("assets/images/Art_Circle2Connections.png")',
    backgroundSize: '70%',
    height: '200px',
    backgroundPosition: '245% center',
    backgroundRepeat: 'no-repeat',
}));

const KpiTitle = styled(Typography)(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: '600',
    color: theme.palette.green.main,
    fontFamily: 'Lora',
}));

const KpiValue = styled(Typography)(({ theme }) => ({
    fontSize: '3.5rem',
    fontWeight: '600',
    color: theme.palette.gray.main,
}));

const KPI = ({ options }) => {
    const { qlikApp } = useContext(AppContext);

    const qkpiDataOptions = useQlikSessionObject({
        app: qlikApp,
        properties: {
            qHyperCubeDef: {
                qDimensions: [],
                qMeasures: [
                    {
                        qDef: {
                            qDef: options.measure,
                        },
                    },
                ],
            },
        },
    });

    const optionsKpi = useMemo(() => {
        if (!qkpiDataOptions.layout) return [];
        const opts = qkpiDataOptions.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => ({
            qElemNumber: row[0].qElemNumber,
            qState: row[0].qState,
            qText: row[0].qText,
        }));
        return opts[0].qText;
    }, [qkpiDataOptions.layout]);

    return (
        <KPIWrapper>
            <Paper
              elevation={3}
              sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: '10px',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                }}
            >
                <KpiTitle>{options.title}</KpiTitle>
                <KpiValue>{optionsKpi}</KpiValue>
            </Paper>
        </KPIWrapper>
    );
};

KPI.propTypes = {
    options: PropTypes.object.isRequired,
};

export default KPI;
